import React, { useEffect } from "react";
import Header from "../Templete/Header";
import Footer from "../Templete/Footer";
import WhyChooseUs from "../Home/WhyChooseUs";

const Services = () => {
  useEffect(() => {
    document.title = "Our Services | FORMAX PAY";
  }, []);

  const services = [
    {
      id: 1,
      name: "Mobile Recharge",
      icon: "fas fa-mobile-alt",
      description:
        "We offers quick, secure mobile recharges for all major telecom operators in India, ensuring seamless connectivity anytime, anywhere.",
      color: "#1e40af",
    },
    {
      id: 2,
      name: "DTH Recharge",
      icon: "fas fa-tv",
      description:
        "We provides fast and easy DTH recharges for all major service providers, ensuring uninterrupted entertainment at your convenience.",
      color: "#1e40af",
    },
    {
      id: 3,
      name: "Google Play Recharge",
      icon: "fab fa-google-play",
      description:
        "We offers quick and secure Google Play recharges, giving you instant access to apps, games, and more, anytime you need.",
      color: "#1e40af",
    },
    {
      id: 4,
      name: "Utility Bill Payments",
      icon: "fas fa-receipt", // Changed from fa-file-invoice-dollar to bill/receipt icon
      description:
        "We provide fast and secure bill payment services for electricity, water, gas, and more—ensuring hassle-free and timely payments at your convenience.",
      color: "#1e40af",
    },
    // {
    //   id: 5,
    //   name: "Brand Vouchers",
    //   icon: "fas fa-gift", // Changed from fa-ticket-alt to gift icon (more reliable)
    //   description:
    //     "We offer instant brand vouchers for top brands, making gifting and shopping easy, secure, and convenient anytime.",
    //   color: "#1e40af",
    // },
  ];

  const handleServiceClick = (serviceName) => {
    alert(`You selected ${serviceName}. This feature will be available soon.`);
  };

  return (
    <>
      <Header />

      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1>Our Services</h1>
          <p>
            Fast, secure & rewarding recharges and bill payments – all in one
            place.
          </p>
        </div>
      </section>

      <div className="container">
        <div className="services-page">
          <div className="services-intro">
            <p>
              FORMAX PAY offers simple and reliable essential services including
              mobile recharge, DTH recharge, Google Play recharge, and utility
              bill payments, ensuring fast processing, secure transactions, and
              a smooth user experience for all your everyday needs
            </p>
          </div>

          <div className="services-grid-page">
            {services.map((service) => (
              <div className="service-card-page" key={service.id}>
                <div
                  className="service-icon-page"
                  style={{ background: "#eef2ff", color: service.color }}
                >
                  <i className={service.icon}></i>
                </div>
                <h3>{service.name}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>

          <WhyChooseUs />
        </div>
      </div>

      <Footer />

      {/* Additional CSS for services page */}
      <style>{`
        .page-hero {
          background: linear-gradient(120deg, #eef2ff 0%, #f0f9ff 100%);
          padding: 50px 0 60px;
          text-align: center;
        }
        .page-hero h1 {
          font-size: 2.8rem;
          margin-bottom: 12px;
        }
        .page-hero p {
          color: #334155;
          max-width: 600px;
          margin: 0 auto;
        }
        .services-page {
          margin: 60px 0;
        }
        .services-intro {
          text-align: center;
          max-width: 800px;
          margin: 0 auto 50px auto;
          font-size: 1.1rem;
          color: #334155;
          line-height: 1.6;
        }
        .services-grid-page {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 32px;
          margin-bottom: 60px;
        }
        .service-card-page {
          background: white;
          border-radius: 28px;
          padding: 32px 24px;
          text-align: center;
          transition: all 0.3s ease;
          box-shadow: var(--shadow-sm, 0 10px 25px -5px rgba(0,0,0,0.05));
          border: 1px solid #eef2ff;
        }
        .service-card-page:hover {
          transform: translateY(-8px);
          box-shadow: var(--shadow-hover, 0 25px 30px -12px rgba(0,0,0,0.15));
          border-color: #cbdffc;
        }
        .service-icon-page {
          font-size: 3rem;
          width: 80px;
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          margin: 0 auto 24px;
        }
        .service-card-page h3 {
          font-size: 1.5rem;
          margin-bottom: 12px;
          font-weight: 700;
          color: #0f172a;
        }
        .service-card-page p {
          color: #475569;
          margin-bottom: 24px;
          line-height: 1.5;
        }
        .service-btn {
          background: linear-gradient(95deg, #1e40af, #2563eb);
          color: white;
          padding: 10px 24px;
          border-radius: 48px;
          font-weight: 600;
          border: none;
          cursor: pointer;
          transition: all 0.2s;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          font-size: 0.95rem;
        }
        .service-btn:hover {
          background: linear-gradient(95deg, #1e3a8a, #1e40af);
          transform: translateY(-2px);
        }
        .services-benefits {
          background: #f8fafc;
          border-radius: 32px;
          padding: 48px 32px;
          text-align: center;
        }
        .services-benefits h2 {
          font-size: 2rem;
          margin-bottom: 40px;
          color: #0f172a;
        }
        .benefits-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 32px;
        }
        .benefit-item i {
          font-size: 2.5rem;
          color: #1e40af;
          margin-bottom: 16px;
        }
        .benefit-item h4 {
          font-size: 1.2rem;
          margin-bottom: 8px;
          color: #0f172a;
        }
        .benefit-item p {
          color: #475569;
          font-size: 0.9rem;
        }
        @media (max-width: 720px) {
          .page-hero h1 { font-size: 2rem; }
          .services-benefits h2 { font-size: 1.6rem; }
          .service-card-page h3 { font-size: 1.3rem; }
        }
      `}</style>
    </>
  );
};

export default Services;
